import { render } from "./horizondalpercentage.vue?vue&type=template&id=9d7f736a"
import script from "./horizondalpercentage.vue?vue&type=script&lang=js"
export * from "./horizondalpercentage.vue?vue&type=script&lang=js"

import "./horizondalpercentage.vue?vue&type=style&index=0&id=9d7f736a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__